import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import QRCode from 'qrcode.react'
import { Box, Typography, Button } from '@mui/material'
import { TwoFactorStatus } from '@/enums/two-factor-status.enum'

import TwoFactorDigitsComponent from '@/views/components/two-factor-digits/index.component'
import { usersSelector } from '@/state/user/slices/index.slices'

type Props = {
  activeStep: number
  twoFactorVerified: TwoFactorStatus
  handleStep: (value: number) => void
  handleGetSecretCode: () => void
}

const TwoFactorActiveOneComponent = ({
  activeStep,
  twoFactorVerified,
  handleStep,
  handleGetSecretCode,
}: Props) => {
  const { t } = useTranslation()

  const { secretCode } = useSelector(usersSelector)

  useEffect(() => {
    if (secretCode === '') {
      handleGetSecretCode()
    }
  }, []) // eslint-disable-line

  return (
    <>
      <Box mt={2}>
        <Typography className="fontWeight-500" paragraph>
          {t('twoFactor.configureAuthenticator')}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: t('twoFactor.configureAuthenticatorStepOne'),
        }}
      />
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: t('twoFactor.configureAuthenticatorStepTwo'),
        }}
      />
      <Typography
        variant="body2"
        dangerouslySetInnerHTML={{
          __html: t('twoFactor.configureAuthenticatorStepThree'),
        }}
      />
      <Box
        border="1px solid"
        borderRadius="4px"
        padding={2.5}
        my={2}
        display="flex"
        justifyContent="center"
      >
        {activeStep === 1 && secretCode !== '' && (
          <QRCode
            value={secretCode}
            size={150}
            bgColor="#000000"
            fgColor="#FFFFFF"
          />
        )}
      </Box>
      <Box textAlign="center">
        <Button onClick={() => handleStep(2)} className="link">
          {activeStep === 1 ? t('twoFactor.canYouScanIt') : ''}
        </Button>
      </Box>
      <Box mt={4}>
        <TwoFactorDigitsComponent
          verificationCode
          twoFactorStatus={twoFactorVerified}
        />
      </Box>
    </>
  )
}

export default TwoFactorActiveOneComponent
